<template>
  <MdEditor
    :toolbars="mdEditorToolbars"
    :showToolbarName="true"
    @click.stop
    @dblclick.stop
    @mousedown.stop
    @wheel.stop
    v-model="textVal"
    @onSave="save"
    :style="{
      height: '25rem',
    }"
  >
  </MdEditor>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive, markRaw,
  h, defineComponent, toRaw,
} from 'vue';
import store from '@/store';
import { isNull, dayjs, message, vueCreateAppInit } from '@/utils/js/initVariable';

import { MdEditor } from 'md-editor-v3';

// props
const props = defineProps({
  text: { type: String, },
});
// emit
const emit = defineEmits([
  'save',
]);

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

// md编辑工具
const mdEditorToolbars = store.getters['mdEditor/getMdEditorToolbars'];
const textVal = ref(props.text || '');

const save = (val)=>{
  emit('save', val);
}

</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>